// src/services/businessReplyConfig.service.ts

import axios from "axios";

/* ---------------- BASE CONFIG ---------------- */

const BASE_URL =
  process.env.REACT_APP_PYTHON_BACKEND_URL || "http://localhost:8000/";

const API_PATH = "admin/business-reply-config";

/* ---------------- AXIOS INSTANCE ---------------- */

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

/* ---------------- GET CONFIG ---------------- */

export const getBusinessReplyConfig = async (businessId: string) => {
  const res = await api.get(`${API_PATH}/${businessId}`);
  return res.data;
};

/* ---------------- ADD NUMBER ---------------- */

export const addDisabledNumber = async (businessId: string, phone: string) => {
  const res = await api.post(`${API_PATH}/${businessId}/add`, {
    phone,
  });
  return res.data;
};

/* ---------------- REMOVE NUMBER ---------------- */

export const removeDisabledNumber = async (
  businessId: string,
  phone: string,
) => {
  const res = await api.post(`${API_PATH}/${businessId}/remove`, {
    phone,
  });
  return res.data;
};
